export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["MONEY_OFF_AMOUNT"] = "MONEY_OFF_AMOUNT";
    Type["PERCENT_OFF_RATE"] = "PERCENT_OFF_RATE";
    Type["FREE_SHIPPING"] = "FREE_SHIPPING";
    Type["FIXED_PRICE_AMOUNT"] = "FIXED_PRICE_AMOUNT";
    Type["BUY_X_GET_Y"] = "BUY_X_GET_Y";
})(Type || (Type = {}));
export var Status;
(function (Status) {
    /** Unknown status. */
    Status["UNKNOWN"] = "UNKNOWN";
    /** The reference coupon was created but the loyalty points have not been redeemed yet. */
    Status["PENDING"] = "PENDING";
    /** The reference coupon is active and available to the customer. */
    Status["ACTIVE"] = "ACTIVE";
    /** The reference coupon was applied and is no longer available for use. */
    Status["APPLIED"] = "APPLIED";
    /** The reference coupon was created but something went wrong when redeeming points from the loyalty account. */
    Status["FAILED"] = "FAILED";
    /** The reference coupon was deleted. */
    Status["ARCHIVED"] = "ARCHIVED";
})(Status || (Status = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map